import { Redirect } from 'react-router-dom';

const Auth = () => {
    return <Redirect to="/" />;
};

export default Auth;
